import React from 'react'
import "./research.css";
import Info from './Info.jsx';

const Research = () => {
    return (
        <section className="research section">
            <div className="research__container container grid">
                <h2 className="section__title" id="research">Publications</h2>
                <div className="research__data">
                    <Info />
                </div>
            </div>
        </section>
    )
}

export default Research